








import { Vue, Component } from "@/shared/vuepack";
import { usePayrollReportStore } from "@/employer/store/payrollReport";

@Component({})
export default class EmployeeBankInfoReport extends Vue {
  reportStore = usePayrollReportStore();

  downloadEmployeeBankInfoReport () {
    this.reportStore.generateEmployeeBankInfoReport();
  }
}
